import React, { useContext, ComponentType } from 'react';
import { ELSPageLoader } from '@els/els-ui-common-react';
import IsRender from '../../components/is-render/IsRender.component';
import { AppContext } from '../../components/app/AppProvider.component';

// Note: If you use this before connect it will not work
// eslint-disable-next-line react/display-name
const withPageLoader = <T extends Record<string, unknown>>(WrappedComponent: ComponentType<T>) => (wrappedProps: T): JSX.Element => {
  const { appState, } = useContext(AppContext);
  return (
    <>
      <IsRender isRender={appState.pendingRequestCount > 0}>
        <ELSPageLoader />
      </IsRender>
      <WrappedComponent {...wrappedProps} />
    </>
  );
};

export default withPageLoader;
